// extracted by mini-css-extract-plugin
module.exports = {"container":"_3MIY_","triangleBorder":"_2mNml","defaultColor":"_1jYrr","triangleBackground":"_1k4rc"};